import SmartCallbackScreen from '@/src/auth/smartCallbackScreen';

export default SmartCallbackScreen;
